import { Menu } from 'antd';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import '../App.css';
import { AuthContext } from '../contexts/authContext';
import { routes } from '../routes';

export function NavigationMenu(this: any) {
    const location = useLocation();
    const { t } = useTranslation();
    const match = useRouteMatch({ exact: true, path: location.pathname });
    const history = useHistory();
    const path = match?.path?.trim() || '<none>';

    const authContext = useContext(AuthContext);
    const routesInMenu = routes(authContext.currentUser!).filter(r => r.navigationMenu);

    const onNav = (key: string) => {
        history.push(routesInMenu[parseInt(key)].path);
    };

    const matchingRoutes = routesInMenu.filter(r => path.startsWith(r.path));
    let matchingRoute = matchingRoutes.length ? matchingRoutes[0] : undefined;
    if (matchingRoute && matchingRoutes.length > 1) {
        for (let i = 1; i < matchingRoutes.length; i++) {
            if (matchingRoutes[i].path.length > matchingRoute.path.length) {
                matchingRoute = matchingRoutes[i];
            }
        }
    }

    const selectedKeys = matchingRoute ? [routesInMenu.indexOf(matchingRoute).toString(10)] : [];

    const menuItems = routesInMenu.map((r, i) => ({
        key: i.toString(),
        label: t(r.navigationMenu!.labelKey),
    }));

    return (
        <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={selectedKeys}
            onClick={e => onNav(e.key.toString())}
            items={menuItems}
        />
    );
}